import React from "react";
import classNames from "classnames";
import styles from "./fix-pager-number.module.scss";
import { FixButton } from "@/elements-react/fix-button";
import {useCallback} from "preact/hooks";

export interface FixPagerNumberProps {
    active?: boolean;
    onClick?: () => void;
    className?: string;
    children?: React.ReactNode;
    currentUrl?: string;
    page?: number;
}

export const FixPagerNumber = ({
                                   active,
                                   onClick,
                                   className,
                                   children,
                                   page,
                                   currentUrl,
                               }: FixPagerNumberProps) => {
    const href = (() => {
        const [pathname = "", rawSearch = ""] = (currentUrl ?? "").split("?");
        const params = new URLSearchParams(rawSearch);

        if (!page || page <= 1) params.delete("page");
        else params.set("page", String(page));

        const q = params.toString();
        return q ? `${pathname}?${q}` : pathname;
    })();

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            if ( e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            onClick?.();
        },
        [onClick]
    );
    return (
        <FixButton
            href={href}
            variant="text"
            className={classNames(className, styles.root, { [styles.active]: active })}
            onClick={(e) => handleClick(e as any)}
            aria-current={active ? "page" : undefined}
        >
            {children}
        </FixButton>
    );
};